<script>
export default {
    name: "NursingNotesTab",

    props: {
        nursingFile: Object,
        encounters: Array,
    },
}
</script>
<template>
    <div class="w-full p-1 my-1">
        <div class="w-full flex flex-wrap" v-for="encounter in encounters" :key="encounter.encounterId">
            <div class="md:w-1/5 w-full p-1 border bg-gray-200">
                <h5 class="font-medium text-base">Encounter Created By:</h5>
            </div>
            <div class="md:w-4/5 w-full p-1 border bg-gray-200">
                <h5 class="font-medium text-sm">{{encounter.userName}}</h5>
            </div>
            <div class="md:w-1/5 w-full p-1 border bg-gray-200">
                <h5 class="font-medium text-base">Created At:</h5>
            </div>
            <div class="md:w-4/5 w-full p-1 border bg-gray-200">
                <h5 class="font-medium text-sm">{{encounter.sysDate | dateFormatDT}}</h5>
            </div>
            <div class="w-full flex flex-wrap border my-px" 
                v-if="nursingFile.nursingCarePlan.filter(carePlan => carePlan.encounterId==encounter.encounterId).length">
                <div class="md:w-1/5 w-1/4 p-1">
                    <h5 class="font-bold text-lg">
                        Nursing CarePlan
                    </h5>
                </div>
                <div class="md:w-4/5 w-3/4 flex flex-wrap p-1">
                    <div class="w-full p-1" 
                        v-for="carePlan in nursingFile.nursingCarePlan.filter(carePlan => carePlan.encounterId==encounter.encounterId)" :key="carePlan.planId">
                        <h5 class="mb-px font-medium">Assessment: {{carePlan.assesment}}</h5>
                        <span class="mb-1" v-html="carePlan.notes"></span>
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-wrap border my-px" v-if="nursingFile.nursingCardex.length && 
                nursingFile.nursingCardex.filter(cardex => cardex.encounterID==encounter.encounterId).length">
                <div class="md:w-1/5 w-1/4 p-1">
                    <h5 class="font-bold text-base">Nursing Cardex</h5>
                </div>
                <div class="md:w-4/5 w-3/4 p-1">
                    <div class="my-px" 
                        v-for="cardex in nursingFile.nursingCardex.filter(cardex => cardex.encounterID==encounter.encounterId)" 
                        :key="cardex.patientNursingRecordId">
                        <span v-html="cardex.cardexNotes"></span>
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-wrap border my-px" 
                v-if="nursingFile.patientVitals.length && nursingFile.patientVitals.filter(vital => vital.encounterId==encounter.encounterId)">
                <div class="md:w-1/5 w-1/4 p-1">
                    <h5 class="text-base font-bold">Vitals</h5>
                </div>
                <div class="md:w-4/5 w-3/4 flex flex-wrap p-1">
                    <div class="w-full flex flex-row p-1 border-b" 
                        v-for="(vital,idx) in nursingFile.patientVitals.filter(vital => 
                            vital.encounterId==encounter.encounterId)" :key="idx">
                        <div class="w-1/3">
                            <h5 class="font-medium text-sm">
                                <span class="mr-3">Time:</span>
                                <span>{{ vital.sysDate | dateFormatDT }}</span> </h5>
                        </div>
                        <div class="w-1/3">
                            <h5 class="font-medium text-sm">
                                <span class="mr-3">{{vital.parameter}}:</span>
                                <span>{{vital.value}}</span></h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-wrap border my-px" 
                v-if="nursingFile.nursingFluidBalanceCharts.length && 
                    nursingFile.nursingFluidBalanceCharts.filter(fBC => fBC.encounterId ==encounter.encounterId).length">
                <div class="md:w-1/5 w-1/4 p-1">
                    <h5 class="font-bold text-base">Fluid Balance Chart</h5>
                </div>
                <div class="w-4/5 w-3/4 flex flex-wrap p-1">
                    <div class="w-full flex flex-wrap overflow-auto my-1" 
                        v-for="fBC in nursingFile.nursingFluidBalanceCharts.filter(fBC => fBC.encounterId ==encounter.encounterId)" 
                        :key="fBC.fluidId">
                        <div class="w-full flex flex-row bg-gray-100 my-px">
                            <div class="flex-1 p-1">
                                <h5 class="text-base">
                                    <span class="font-bold mr-3">Input Name:</span>
                                    <span>{{fBC.inputName}}</span></h5>
                            </div>
                            <div class="flex-1 p-1">
                                <h5 class="text-base">
                                    <span class="font-bold mr-3">Input Route:</span>
                                    <span>{{fBC.inputRoute}}</span></h5>
                            </div>
                            <div class="flex-1 p-1">
                                <h5 class="text-base">
                                    <span class="font-bold mr-3">Input Amount:</span>
                                    <span>{{fBC.inputFluidAmount}}</span></h5>
                            </div>
                            <div class="flex-1 p-1">
                                <h5 class="text-base">
                                    <span class="font-bold mr-3">Input Date:</span>
                                    <span>{{fBC.inputDate | dateFormat}}</span>
                                </h5>
                            </div>
                            <div class="flex-1 p-1">
                                <h5 class="text-base">
                                    <span class="font-bold mr-3">Input Time:</span>
                                    <span>{{fBC.inputTime}}</span>
                                </h5>
                            </div>
                        </div>
                        <div class="w-full flex flex-row my-px">
                            <div class="flex-1 p-1">
                                <h5 class="text-base">
                                    <span class="mr-3 font-bold">Output Name:</span>
                                    <span>{{fBC.outputName}}</span></h5>
                            </div>
                            <div class="flex-1 p-1">
                                <h5 class="text-base">
                                    <span class="mr-3 font-bold">Output Route:</span>
                                    <span>{{fBC.outputRoute}}</span></h5>
                            </div>
                            <div class="flex-1 p-1">
                                <h5 class="text-base">
                                    <span class="mr-3 font-bold">Output Amount:</span>
                                    <span>{{fBC.outputFluidAmount}}</span></h5>
                            </div>
                            <div class="flex-1 p-1">
                                <h5 class="text-base">
                                    <span class="mr-3 font-bold">Output Date:</span>
                                    <span>{{fBC.outputDate | dateFormat}}</span></h5>
                            </div>
                            <div class="flex p-1">
                                <h5 class="text-base">
                                    <span class="mr-3 font-bold">Output Time:</span>
                                    <span>{{fBC.outputTime}}</span></h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    @media print {
        .hide--print{
            display: none;
        }
        h5 {
            color: black;
        }
    }
</style>
